<template>
  <div>
    <PageTitleVue> Estoque </PageTitleVue>

    <section>
      <div
        class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2"
      >
        <div
          class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white"
        >
          <SearchInput v-model="searchTerm" />
        </div>

        <DataTable :data="filteredData">
          <template #head>
            <th scope="col" class="px-6 py-3">Item</th>
            <th scope="col" class="px-6 py-3">Descrição</th>
            <th scope="col" class="px-6 py-3">CA</th>
            <th scope="col" class="px-6 py-3 text-center">#</th>
          </template>
        </DataTable>
      </div>
    </section>

    <FloatCreateVue :link="'stock-new'" />
  </div>
</template>

<script setup>
import DropDownOptions from "@/components/Tables/DropDownOptions.vue";
import PageTitleVue from "./../../components/Titles/PageTitle.vue";
import FloatCreateVue from "@/components/Buttons/FloatCreate.vue";
import StockService from "./services/stock.service";
import DataTable from "./components/DataTable.vue";
import StockTable from "./components/Table.vue";
import { onBeforeMount, onMounted, ref, computed } from "vue";
import { showToast as toast } from "@/helpers/UseToasts";
import { dataStock } from "./store";
import { storeApp } from "@/store";

import SearchInput from "@/components/Tables/SearchInput.vue";

const store = dataStock;
const appStore = storeApp.state;
const dataTable = ref([]);
const searchTerm = ref("");

const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase();

  return dataTable?.value?.filter((row) => {
    const matchesSearch =
      !searchTerm.value ||
      ["name", "description", "size", "inventory", "CA"].some(
        (key) =>
          row[key] &&
          row[key].toString().toLowerCase().includes(searchTermLower)
      );

    return matchesSearch;
  });
});

async function getItens() {
  await StockService.getAllItens()
    .then((res) => {
      dataTable.value = res.data;
    })
    .catch((err) => {
      toast("Aviso", "Algo deu errado o buscar itens do estoque", "error");
    });
}

onBeforeMount(() => {
  store.commit("reset");
}),
  onMounted(async () => {
    appStore.loading = true;
    await getItens();
    appStore.loading = false;
  });
</script>
